<template>
  <div>
    <vs-row vs-w="12" class="mb-2 mb-4">
      <vs-alert title="Aviso" color="danger" v-if="msg != ''">
        {{ msg }}
      </vs-alert>
    </vs-row>
    <qb-upload
      :showUploadButton="false"
      @on-delete="handleDelete"
      @update-file="handleUpdate"
      accept="application/xml,application/pdf,text/xml"
      multiple
      :reset="reset"
    />
  </div>
</template>

<script>
import QbUpload from '@/components/upload/QbUpload.vue'
export default {
  components: {
    QbUpload,
  },
  data() {
    return {
      data: null,
      limit: 40,
      msg: '',
      name: '',
      files: [],
      expenseFiles: {
        xml: null,
        pdf: null,
        others: [],
      },
      reset:false,
    }
  },
  methods: {
    handleDelete(e) {
      let i = this.files.findIndex((item) => item === e)
      this.files.splice(i, 1)
      this.updateExpenseFiles()
    },
    handleUpdate(e) {
      this.files = [...this.files, ...e]
      this.updateExpenseFiles()
    },
    updateExpenseFiles() {
      this.clear()
      let status = true
      let files = this.sortFiles(this.files)
      files.map((file) => {
        if (file.type === 'text/xml' || file.type === 'application/xml') {
          if (this.name === '') {
            this.name = String(file.name).toLowerCase().split('.xml')[0]
          }
          if (this.expenseFiles.xml === null) {
            this.expenseFiles.xml = file
          } else {
            status = false
            this.msg = 'Solo esta permitido un archivo XML.'
          }
        }
        if (file.type === 'application/pdf') {
          let pdfName = String(file.name).toLowerCase().split('.pdf')[0]
          if (pdfName === this.name) {
            if (this.expenseFiles.pdf === null) {
              this.expenseFiles.pdf = file
            } else {
              status = false
              this.msg =
                'Solo esta permitido un archivo PDF nombrado como el XML.'
            }
          } else {
            this.expenseFiles.others = [...this.expenseFiles.others, file]
          }
        }
      })
      if (this.expenseFiles.xml === null || this.expenseFiles.pdf === null) {
        status = false
      }
      if (this.files.length > this.limit) {
        status = false
        this.msg = `Solo esta permitido un máximo de ${this.limit} archivos.`
      }
      // console.log('update', this.expenseFiles)
      this.$emit('update', { status, files: this.expenseFiles })
    },
    sortFiles(items) {
      let files = [...items]
      files.sort(function (a, b) {
        if (a.type < b.type) {
          return 1
        }
        if (a.type > b.type) {
          return -1
        }
        return 0
      })
      return files
    },
    restart() {
      this.reset = !this.reset
      this.files = []
      this.updateExpenseFiles()
    },
    clear() {
      this.msg = ''
      this.name = ''
      this.expenseFiles = Object.assign(
        {},
        {
          xml: null,
          pdf: null,
          others: [],
        }
      )
    },
  },
  watch: {
    reset() {
      this.files = []
    },
  },
}
</script>

<style>
</style>
